<template>
    <div class="gz-input-container__validation" :class="{'gz-input-container_not-valid': !valid}">
        <transition name="fade" appear>
            <span v-if="!valid">{{ validationMessage }}</span>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'BaseValidationMArk',

    props: {
        valid: {
            type: Boolean,
            default: true
        },
        validationMessage: {
            type: String,
            default: 'Обязательно для заполнения'
        }
    }
}
</script>